import * as React from 'react';
import { Link } from 'src/components/common/Link';
import { Header, Table } from '@amzn/awsui-components-react-v3';

export interface ResourceSummaryTableProps {
  loading: boolean;
  items: readonly any[];
}

export const ResourceSummaryTable = (props: ResourceSummaryTableProps) => {
  return (
    <Table
      loading={props.loading}
      columnDefinitions={[
        {
          id: 'resource',
          header: 'Resource',
          cell: (item) => <Link href={item.resourceLink}>{item.resource}</Link>,
        },
        {
          id: 'type',
          header: 'Resource type',
          cell: (item) => item.type,
        },
      ]}
      items={props.items}
      loadingText='Loading resources'
      sortingDisabled
      header={<Header> Resources </Header>}
    />
  );
};
